cv.SetupTeamsView = Marionette.CompositeView.extend({
  template: cv.Templates['setup/teams/setup_teams'],
  childViewContainer: '.results',
  childView: cv.SetupTeamsRowView,
  emptyView: cv.SetupTeamsRowEmptyView,

  events : {
    'click .next' : 'next'
  },

  behaviors: [{
    behaviorClass: cv.PaginateBehavior
  }],

  validation: {
  },

  templateHelpers: function(){
    return {
      use_default_appeal : cv.setup.get('use_default_appeal') == 1 ? true : false
    };
  },

  initialize: function(options){
    this.mergeOptions(options, this.options);

    // Defaults
    this.collection.params.filter = [];

    console.log('SetupTeamsView initialized.');
  },

  next: function(e){
    e.preventDefault();

    top.location = '/me';
  },

  isEmpty: function(collection){
    if(collection.num_records > 0 || _.isUndefined(collection.num_records)){
      return false;
    }
    if(collection.num_records == 0){
      this.$('.pagination').remove();
      return true;
    }
  },

  attachHtml: function(collectionView, childView, index){
    if (collectionView.isBuffering) {
      // buffering happens on reset events and initial renders
      // in order to reduce the number of inserts into the
      // document, which are expensive.
      collectionView._bufferedChildren.splice(index, 0, childView);
    }else {
      // If we've already rendered the main collection, append
      // the new child into the correct order if we need to. Otherwise
      // append to the end.
      if (!collectionView._insertBefore(childView, index)){
        collectionView._insertAfter(childView);
      }
    }
  },

  onShow: function(){
    $('#content').scrollTop(0);

    // Fetch the results
    this.collection.fetch({
      reset: true
    });

    // Search timer
    var typingTimer;
    var self = this;
    this.$('#input-search').keyup(function(){
      clearTimeout(typingTimer);
      typingTimer = setTimeout(function(){
        self.collection.params.term = encodeURI(this.$('#input-search').val());
        self.collection.fetch({
          reset : true
        });
      }, 500);
    });

    // Change document title
    document.title = 'Setup | Join a Team';

    this.renderBottom();
  },

  renderBottom: function(){
    console.log('Rendering bottom...');

    var total_steps = 3;
    var current_step = 3;

    cv.renderProgressSteps(current_step, total_steps, this);
  },

  onRender: function(){
  }
});
